import { JOSENotSupported } from '../util/errors.js';
export default function subtleDsa(alg, algorithm) {
  var hash = "SHA-".concat(alg.slice(-3));
  switch (alg) {
    case 'HS256':
    case 'HS384':
    case 'HS512':
      return {
        hash: hash,
        name: 'HMAC'
      };
    case 'PS256':
    case 'PS384':
    case 'PS512':
      return {
        hash: hash,
        name: 'RSA-PSS',
        saltLength: alg.slice(-3) >> 3
      };
    case 'RS256':
    case 'RS384':
    case 'RS512':
      return {
        hash: hash,
        name: 'RSASSA-PKCS1-v1_5'
      };
    case 'ES256':
    case 'ES384':
    case 'ES512':
      return {
        hash: hash,
        name: 'ECDSA',
        namedCurve: algorithm.namedCurve
      };
    case 'Ed25519':
      return {
        name: 'Ed25519'
      };
    case 'EdDSA':
      return {
        name: algorithm.name
      };
    default:
      throw new JOSENotSupported("alg ".concat(alg, " is not supported either by JOSE or your javascript runtime"));
  }
}